import React, { useState, useEffect } from "react";
import FSLoader from "../Loaders/FSLoader";
import "./instaFeed.css";

const InstaFeed = () => {
  const [feed, setFeed] = useState([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    fetch(
      "https://instafeed.nfcube.com/feed/v6?limit=16&account=blancreme.myshopify.com&fu=0&fid=0&hash=a9e6ddad3b078449637b85730140c377&locale=fr&handle=",
    )
      .then((res) => res.json())
      .then((data) => {
        setFeed(data.data || []);
        setIsLoading(false);
      })
      .catch((err) => {
        console.error("Error fetching instagram feed:", err);
        setIsLoading(false);
      });
  }, []);

  if (isLoading) {
    return <FSLoader />;
  }

  return (
    <div className="instafeed-grid">
      {feed.map((post) => (
        <a
          key={post.id}
          href={post.link}
          target="_blank"
          rel="noopener noreferrer"
          className="instafeed-item"
        >
          <img
            src={post.images.standard_resolution.url}
            alt={post.caption?.text || "Instagram post"}
          />
          <div className="instafeed-overlay">
            <i className="fa fa-instagram"></i>
          </div>
        </a>
      ))}
    </div>
  );
};
export default InstaFeed;
